import Autosuggest from 'react-autosuggest';
import React from 'react';
import { connect } from 'react-redux';

import util from '../../functions/Utilities';
import removeImg from '../../images/remove.png';
import { setSearchName } from '../../actions/doaAction';
import api from '../../api/api';
import uri from '../../variables/uri';

class FormSuggestUserWithAdd extends React.Component {
    state = {
        suggestions: []
    };

    componentDidMount = async () => {
        this.list = [];
        this.onClear();
    }

    getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        return inputLength === 0 ? [] : this.list.filter(item =>
            (item.FirstNameEN.toLowerCase() + ' ' + item.LastNameEN.toLowerCase()).includes(inputValue) || (item.FirstNameTH.toLowerCase() + ' ' + item.LastNameTH.toLowerCase()).includes(inputValue) || item.EmailAddressBusiness.toLowerCase().includes(inputValue)
        );
    };

    getSuggestionValue = suggestion => {
        this.props.handleSelect(suggestion);
        return `${suggestion.FirstNameEN} ${suggestion.LastNameEN} (${suggestion.EmailAddressBusiness})`;
    }

    renderSuggestion = suggestion => (
        <div>
            {`${suggestion.FirstNameEN} ${suggestion.LastNameEN} - ${suggestion.FirstNameTH} ${suggestion.LastNameTH} (${suggestion.EmailAddressBusiness})`}
        </div>
    );

    onChange = (event, { newValue }) => {
        this.props.setSearchName(newValue);

    };

    onSuggestionsFetchRequested = ({ value }) => {
        clearTimeout(this.timeout);
        if (value.length > 2) {
            this.timeout = setTimeout(async () => {
                const url = `${uri.GET_FIND_USER}?search=${value}&bu=${util.getGdc(this.props.gdc)}&headOfOrg=false&searchBy=all`;
                var response = await api.get(url);
                this.list = response.data;
                this.setState({ suggestions: this.getSuggestions(value) });
            }, 700);
        }
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onClear = () => {
        this.props.setSearchName('');
        this.props.handleSelect();
    }

    onAdd=()=>{
        this.props.add();
    }

    render() {
        const { suggestions } = this.state;

        const inputProps = {
            placeholder: '',
            value: this.props.searchName,
            onChange: this.onChange
        };

        return (
            <div className="flex-v mt-16">
                <div className="flex-container-horizontal" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="flex-container-horizontal flex-center">
                        <h4>{this.props.name} :</h4>
                    </div>
                </div>
                <div className="flex-h">
                    <div className="flex-1">
                        <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={inputProps}
                        />
                    </div>
                    <div onClick={() => this.onClear()} className="flex-v flex-center pl-16">
                        <img src={removeImg} alt="" style={{ width: '25px', cursor: 'pointer' }} />
                    </div>
                    <div className="flex-v flex-center pl-16">
                        <button onClick={() => this.onAdd()} className="button is-success center">Add</button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        gdc: state.doa.gdc,
        searchName: state.doa.name,
        user: state.doa.user
    }
}
export default connect(mapStateToProps, {
    setSearchName
})(FormSuggestUserWithAdd);